export const GET_BOTS_ACTIVITY_OVERVIEW = 'GET_BOTS_ACTIVITY_OVERVIEW';
export const GET_BOTS_ACTIVITY_TIMESERIES = 'GET_BOTS_ACTIVITY_TIMESERIES';
export const GET_BOTS_ACTIVITY_CONTENT = 'GET_BOTS_ACTIVITY_CONTENT';
export const GET_BOTS_ACTIVITY_STATUS = 'GET_BOTS_ACTIVITY_STATUS';
